<template>
  <div class="tw:bg-white tw:pt-[60px] tw:pb-12">
    <ContainerLayout class="tw:flex tw:flex-col">
      <h1
        class="tw:text-[28px] tw:leading-[35px] tw:md:text-[44px] tw:md:leading-[55px] tw:mx-auto"
        v-html="$t('rc_product_page_start_rc_header')"
      />
      <div class="tw:flex tw:flex-wrap tw:gap-6 tw:py-6 tw:md:py-12">
        <div
          v-for="step in steps"
          :key="step.id"
          :data-testid="`rate-connect-step-${step.id}`"
          class="tw:bg-gray-200 tw:p-6 tw:rounded-2xl tw:w-full tw:md:w-[calc(50%-12px)] tw:lg:w-[calc(25%-18px)]"
        >
          <img class="tw:pb-4" :src="step.img" :alt="$t(step.title)" />
          <h4 class="card-title tw:pb-3 tw:font-bold tw:text-xl">{{ $t(step.title) }}</h4>
          <p>{{ $t(step.text) }}</p>
        </div>
      </div>

      <div class="tw:flex tw:flex-col tw:mx-auto tw:mb-6">
        <h3 class="tw:text-[32px] tw:leading-[40px] tw:mb-6 tw:text-center" v-html="$t('rc_product_page_cp_header')" />

        <RateConnectConnectivityProviders :withHeader="false" />
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-2 tw:items-start">
        <small class="tw:text-sm">{{ $t('rc_product_page_disclaimer') }}</small>
        <small class="tw:text-sm">{{ $t('rc_product_page_footnote') }}</small>
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import ContainerLayout from '@/layouts/ContainerLayout.vue'
import RateConnectConnectivityProviders from '@/components/productPage/rateConnect/RateConnectConnectivityProviders.vue'

const stepOne = new URL('/src/assets/img/rate-connect/step_one.svg', import.meta.url)
const stepTwo = new URL('/src/assets/img/rate-connect/step_two.svg', import.meta.url)
const stepThree = new URL('/src/assets/img/rate-connect/step_three.svg', import.meta.url)
const stepFour = new URL('/src/assets/img/rate-connect/step_four.svg', import.meta.url)

const steps = ref([
  {
    id: 'step_1',
    title: 'rc_product_page_step_1_header',
    text: 'rc_product_page_step_1_text',
    img: stepOne,
  },
  {
    id: 'step_2',
    title: 'rc_product_page_step_2_header',
    text: 'rc_product_page_step_2_text',
    img: stepTwo,
  },
  {
    id: 'step_3',
    title: 'rc_product_page_step_3_header',
    text: 'rc_product_page_step_3_text',
    img: stepThree,
  },
  {
    id: 'step_4',
    title: 'rc_product_page_step_4_header',
    text: 'rc_product_page_step_4_text',
    img: stepFour,
  },
])
</script>
<style scoped>
.card-title {
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
}
</style>
